﻿/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";

export class address extends IceEntity {
    address_key: string = "";
    address_type: IceTypes.addresstype = IceTypes.addresstype.atHome;
    street1: string = "";
    street2: string = "";
    city: string = "";
    state_id: string = "";
    postal_code: string = "";
    province: string = "";
    country_id: string = "";
    record_version: number = 0;
    offline_record_status: number = 0;
    accessed: any = NaN;
    accessed_user: string = "";
    created: any = NaN;
    created_user: string = "";
    modifie: any = NaN;
    modified_user: string = "";

    constructor() {
        super();
    }

    gettablename(): string {
        return "ADDRESS";
    }
}
